module.exports = __webpack_public_path__ + "766b8ca54c1b98b00572105b308fad04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/race-age.svg
// module id = 92
// module chunks = 0